import Button from "components/form/Button";
import Dropdown from "components/form/Dropdown";
import Card from "components/Layout/Card";
import React, { useEffect } from "react";

const PrimaryAndSecondaryCoAuthors = ({
  values,
  handleChange,
  setFieldValue,
  errors,
  onBack,
  onNext,
  btnLoading,
}) => {
  const showCoAuthorSection = values?.co_authors?.length >= 2;

  const duplicateError =
    showCoAuthorSection &&
      values?.primary_co_author &&
      values?.secondary_co_author &&
      values?.primary_co_author === values?.secondary_co_author
      ? "Primary & Secondary Co-authors cannot be the same. Please select different co-authors and review the note below."
      : null;

  useEffect(() => {
    if (showCoAuthorSection) {
      const updated = values.co_authors.map((co) => {
        if (co.email === values.primary_co_author) return { ...co, co_author_status: 1 };
        if (co.email === values.secondary_co_author) return { ...co, co_author_status: 2 };
        return { ...co, co_author_status: 0 };
      });
      setFieldValue("co_authors", updated);
    }
  }, [values.primary_co_author, values.secondary_co_author, showCoAuthorSection]);

  return (
    <Card className="cp-20 cmt-10">
      {showCoAuthorSection && (
        <>
          <div className="text-16-500 color-1717 cmb-20">
            Co-Authors (Primary & Secondary)
          </div>
          <div className="border-bottom cmb-20 color-d1d1"></div>

          <div className="row">
            <div className="col-md-4 cmb-24">
              <Dropdown
                label="Primary Co-Author*"
                id="primary_co_author"
                placeholder="Select Primary Co-Author"
                options={values?.co_authors}
                optionKey="email"
                optionValue="name"
                onChange={handleChange}
                value={values?.primary_co_author}
                error={
                  errors?.primary_co_author && !duplicateError
                    ? errors.primary_co_author
                    : ""
                }
              />
            </div>
            <div className="col-md-4 cmb-24">
              <Dropdown
                label="Secondary Co-Author*"
                id="secondary_co_author"
                placeholder="Select Secondary Co-Author"
                options={values?.co_authors}
                optionKey="email"
                optionValue="name"
                onChange={handleChange}
                value={values?.secondary_co_author}
                error={
                  errors?.secondary_co_author && !duplicateError
                    ? errors.secondary_co_author
                    : ""
                }
              />
            </div>
          </div>

          {duplicateError && (
            <div className="text-danger text-14-400 cmb-10">{duplicateError}</div>
          )}

          <div>
            <span>🎤 Note:</span>
            <br />
            <span className="text-14-500-24">
              👤 Main Author –{" "}
              <span className="text-14-300-24">
                Has the primary right to present.
              </span>
            </span>
            <br />
            <span className="text-14-500-24">
              👩‍💻 Primary Co-author –{" "}
              <span className="text-14-300-24">
                Can present along with the Main Author.
              </span>
            </span>
            <br />
            <span className="text-14-500-24">
              👥 Secondary Co-author –{" "}
              <span className="text-14-300-24">
                May assist, but can present only if the Main Author is unavailable.
              </span>
            </span>
            <br />
            <span className="text-14-500-24">
              👫 Presentation Limit –{" "}
              <span className="text-14-300-24">
                Only two persons are allowed to present physically (either one
                Author and one Co-author, or two Co-authors).
              </span>
            </span>
          </div>
        </>
      )}

      <div className="d-flex gap-3 cmt-20">
        {onBack && (
          <Button
            id="btn_abstract_back"
            text="Back"
            btnStyle="light-outline"
            className="cps-40 cpe-40 h-38"
            onClick={onBack}
            disabled={btnLoading}
          />
        )}
        <Button
          id="btn_abstract_submit"
          text="Save & Proceed"
          btnStyle="primary-dark"
          className="cps-40 cpe-40 h-38"
          onClick={onNext}
          btnLoading={btnLoading}
          disabled={Object.keys(errors).length > 0 || btnLoading}
        />
      </div>
    </Card>
  );
};

export default PrimaryAndSecondaryCoAuthors;
